import { scrollToElement } from '@components/scroll-spy';
import { useRef, useCallback } from 'react';

export const useFocusableDiv = (offset = 160) => {
  const divRef = useRef<HTMLDivElement>();
  const focus = useCallback(() => divRef.current && scrollToElement(divRef.current, offset), [
    divRef,
    offset,
  ]);
  return { divRef, focus };
};
